import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { SkillsClientContext } from 'components/shared/Skills/SkillsClientProvider';

export function useGetSkillProfiles({ limit, offset, searchTerm, sort }) {
  const { client } = useContext(SkillsClientContext);

  const variables = {
    limit,
    offset,
    searchTerm,
    sort,
  };

  return useQuery(
    ['get-profiles', limit, offset, searchTerm, sort],
    async () => {
      return client.request(
        gql`
          query profiles(
            $limit: Int!
            $offset: Int!
            $searchTerm: String
            $sort: ProfileSortOptions
          ) {
            profiles(
              limit: $limit
              offset: $offset
              searchTerm: $searchTerm
              sort: $sort
            ) {
              profiles {
                title
                profileSkillCount
              }
              totalCount
            }
          }
        `,
        variables,
      );
    },
  );
}
